import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { PillTheme } from "@redotech/redo-model/pill-theme";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DataIntegrityError, DatabaseError } from "../auth/errors";

import { ShopperAiTagGroupId, ShopperAiTagId } from "../ids/definitions";

export const TagResponse = Schema.Struct({
  id: ShopperAiTagId,
  name: Schema.String,
  pillTheme: Schema.NullOr(Schema.Enums(PillTheme)),
  tagGroupId: ShopperAiTagGroupId,
});
export type TagResponse = typeof TagResponse.Type;

export const TagGroupResponse = Schema.Struct({
  id: ShopperAiTagGroupId,
  name: Schema.String,
  allowMultipleTags: Schema.Boolean,
  requiredTagBeforeClose: Schema.Boolean,
});
export type TagGroupResponse = typeof TagGroupResponse.Type;

const GetAccountTagsResponse = Schema.Struct({
  tags: Schema.Array(TagResponse),
  tagGroups: Schema.Array(TagGroupResponse),
});

export const TagGroup = HttpApiGroup.make("tag")
  .add(
    endpoint.merchant
      .get("getAccountTags", "/tags")

      .addSuccess(GetAccountTagsResponse)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
